import { Paper, Stack } from '@mui/material';
import { ResultRow } from '../../../pages/Ems/Components/ResultRow';

export function GazeAssessment({ gazeResult }) {
  const formattedValue = (val) => {
    return val ? 'YES' : 'NO';
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Stack spacing={2}>
        <ResultRow title="Gaze Deviation Detected" value={formattedValue(gazeResult?.gazeDeviationDetected)} />
        <ResultRow title="Gaze Palsy Detected" value={formattedValue(gazeResult?.gazePalsyDetected)} />
        <ResultRow title="Dysconjugate Gaze Detected" value={formattedValue(gazeResult?.dysconjugateGazeDetected)} />
      </Stack>
    </Paper>
  );
}
